module.exports = __webpack_public_path__ + "img/929917262.91dd9477.jpg";